import React, { FC } from "react";
import cn from "classnames";
import { Button } from "src/components/Button";
import { BUTTONS } from "./constants";
import { IOptionSelect } from "src/@types/form";

interface Props {
  selectOption: IOptionSelect;
  setSelectOption: React.Dispatch<React.SetStateAction<IOptionSelect>>;
}

export const ToggleButton: FC<Props> = ({ selectOption, setSelectOption }) => {
  const handleToggleButton = (newOption: IOptionSelect) => {
    setSelectOption(newOption);
  };

  return (
    <div className="flex sm:w-150 border rounded-lg">
      {BUTTONS.map(({ id, label, value }) => (
        <Button
          key={id}
          className={cn("flex-1 px-6 py-2 sm:py-4 rounded-lg text-white-base text-10 sm:text-base", {
            "bg-white-base !text-green-base": selectOption?.value === value,
            border: selectOption?.value === undefined,
          })}
          onClick={() => handleToggleButton({ id, label, value })}
        >
          {label}
        </Button>
      ))}
    </div>
  );
};
